<template>
    <div class="">
        <div class="block block-bordered">
            <div class="block-header block-header-default">
                <div class="block-title">
                    Senti Transactions
                </div>

                <!--<download-csv-->
                <!--:data="transactions_mpesa"-->
                <!--class="btn btn-default"-->
                <!--name="filename.csv">-->
                <!--Download Data-->
                <!--<img src="download_icon.png">-->
                <!--</download-csv>-->
            </div>

            <div class="block-content">
                <el-tabs v-model="activeName" @tab-click="handleClick">

                    <el-tab-pane label="Successful Disbursements" name="first">
                        <el-table
                            :data="transactions_success.filter(data => !search || data.disbursement_status.toLowerCase().includes(search.toLowerCase()))"
                            style="width: 100%">

                            <el-table-column
                                label="Status"
                                prop="disbursement_status">
                            </el-table-column>

                            <el-table-column
                                label="Amount Requested"
                                prop="amount_requested">
                            </el-table-column>

                            <el-table-column
                                label="Amount Due"
                                prop="amount_due">
                            </el-table-column>

                            <el-table-column
                                label="Requested Date"
                                prop="approved_date">
                            </el-table-column>

                            <el-table-column
                                label="Due Date"
                                prop="due_date">
                            </el-table-column>

                            <el-table-column
                                align="right">
                                <template slot="header" slot-scope="scope">
                                    <el-input
                                        v-model="search"
                                        size="mini"
                                        placeholder="Type to search"/>
                                </template>

                            </el-table-column>
                        </el-table>
                    </el-tab-pane>


                    <el-tab-pane label="Pending Disbursements" name="second">
                        <el-table
                            :data="transactions_pending.filter(data => !search || data.disbursement_status.toLowerCase().includes(search.toLowerCase()))"
                            style="width: 100%">

                            <el-table-column
                                label="Status"
                                prop="disbursement_status">
                            </el-table-column>

                            <el-table-column
                                label="Amount Requested"
                                prop="amount_requested">
                            </el-table-column>

                            <el-table-column
                                label="Amount Due"
                                prop="amount_due">
                            </el-table-column>

                            <el-table-column
                                label="Requested Date"
                                prop="approved_date">
                            </el-table-column>

                            <el-table-column
                                label="Due Date"
                                prop="due_date">
                            </el-table-column>

                            <el-table-column
                                align="right">
                                <template slot="header" slot-scope="scope">
                                    <el-input
                                        v-model="search"
                                        size="mini"
                                        placeholder="Type to search"/>
                                </template>

                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane label="Failed Disbursements" name="third">
                        <el-table
                            :data="transactions_failed.filter(data => !search || data.disbursement_status.toLowerCase().includes(search.toLowerCase()))"
                            style="width: 100%">

                            <el-table-column
                                label="Status"
                                prop="disbursement_status">
                            </el-table-column>

                            <el-table-column
                                label="Amount Requested"
                                prop="amount_requested">
                            </el-table-column>

                            <el-table-column
                                label="Amount Due"
                                prop="amount_due">
                            </el-table-column>

                            <el-table-column
                                label="Requested Date"
                                prop="approved_date">
                            </el-table-column>

                            <el-table-column
                                label="Due Date"
                                prop="due_date">
                            </el-table-column>

                            <el-table-column
                                align="right">
                                <template slot="header" slot-scope="scope">
                                    <el-input
                                        v-model="search"
                                        size="mini"
                                        placeholder="Type to search"/>
                                </template>

                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import {APP_CONFIG} from "../../config";
    import {Loading} from 'element-ui';
    import {Message} from 'element-ui';

    export default {
        name: "SalaryAdvanceDashboard",
        data() {
            return {
                activeName: 'first',
                transactions_pending: [],
                transactions_success: [],
                transactions_failed: [],
                wallet_balance: '',
                total_success: '',
                total_pending: '',
                total_failed: '',
                search: '',
                loans: '',
                disbursement_status: '',

                // columns_pending: [
                //     'msisdn',
                //     'id_number',
                //     'name',
                //     'amount',
                //     'date_requested',
                //     'due_date'
                // ],
                // options_pending: {
                //     requestFunction: function (data) {
                //         return axios.get(`${APP_CONFIG.URL}projects/${this.$route.params.project}/salary_advance/pending_loans`, {
                //             params: data
                //         }).catch(function (e) {
                //             this.dispatch('error', e);
                //         }.bind(this));
                //     }
                // },
                //
                // options_failed: {
                //     requestFunction: function (data) {
                //         return axios.get(`${APP_CONFIG.URL}projects/${this.$route.params.project}/salary_advance/failed_loans`, {
                //             params: data
                //         }).catch(function (e) {
                //             this.dispatch('error', e);
                //         }.bind(this));
                //     }
                // }
            }
        },
        mounted() {
            this.fetchSuccessfulDisbursements();
            this.fetchPendingDisbursements();
            this.fetchFailedDisbursements();
        },
        methods: {
            /**
             *
             */
            fetchSuccessfulDisbursements() {
                var app = this;
                let loadingInstance = Loading.service({fullscreen: true});

                return axios.get(`${APP_CONFIG.URL}projects/${this.$route.params.project}/salary_advance/successful_loans`, {
                    params: {
                        project: app.$route.params.project
                    }
                }).then(function (resp) {
                    console.log('SUCCESS!!');
                    console.log(JSON.stringify(resp));
                    app.transactions_success = app.getSafe(() => resp.data.data.loans);
                    console.log("################ Status Responses " + JSON.stringify(app.transactions_success));
                    loadingInstance.close();
                    Message.success("Fetched Successfully");
                }).catch(error => {
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    Message.error(error.response.data.message);
                    loadingInstance.close();
                    Message.error("An Error Occurred");
                }).catch(function (resp) {
                    console.log('FAILURE!!');
                    loadingInstance.close();
                    console.log("Status Response " + JSON.stringify(resp));
                    Message.error("An Error Occurred");
                });
            },


            fetchPendingDisbursements() {
                var app = this;
                let loadingInstance = Loading.service({fullscreen: true});

                return axios.get(`${APP_CONFIG.URL}projects/${this.$route.params.project}/salary_advance/pending_loans`, {
                    params: {
                        project: app.$route.params.project
                    }
                }).then(function (resp) {
                    console.log('SUCCESS!!');
                    console.log(JSON.stringify(resp));
                    app.transactions_pending = app.getSafe(() => resp.data.data.loans);
                    console.log("################ Status Responses " + JSON.stringify(app.transactions_success));
                    loadingInstance.close();
                    Message.success("Fetched Successfully");
                }).catch(error => {
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    Message.error(error.response.data.message);
                    loadingInstance.close();
                    Message.error("An Error Occurred");
                }).catch(function (resp) {
                    console.log('FAILURE!!');
                    loadingInstance.close();
                    console.log("Status Response " + JSON.stringify(resp));
                    Message.error("An Error Occurred");
                });
            },


            fetchFailedDisbursements() {
                var app = this;
                let loadingInstance = Loading.service({fullscreen: true});

                return axios.get(`${APP_CONFIG.URL}projects/${this.$route.params.project}/salary_advance/failed_loans`, {
                    params: {
                        project: app.$route.params.project
                    }
                }).then(function (resp) {
                    console.log('SUCCESS!!');
                    console.log(JSON.stringify(resp));
                    app.transactions_failed = app.getSafe(() => resp.data.data.loans);
                    console.log("################ Status Responses " + JSON.stringify(app.transactions_success));
                    loadingInstance.close();
                    Message.success("Fetched Successfully");
                }).catch(error => {
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    Message.error(error.response.data.message);
                    loadingInstance.close();
                    Message.error("An Error Occurred");
                }).catch(function (resp) {
                    console.log('FAILURE!!');
                    loadingInstance.close();
                    console.log("Status Response " + JSON.stringify(resp));
                    Message.error("An Error Occurred");
                });
            },


            handleClick(tab, event) {
                console.log(tab, event);
            },


            getSafe(fn) {
                try {
                    return fn();
                } catch (e) {
                    return undefined;
                }
            },
        }
    }
</script>

<style scoped>
    .VueTables__child-row-toggler {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: block;
        margin: auto;
        text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
        content: "+";
    }

    .VueTables__child-row-toggler--open::before {
        content: "-";
    }
</style>
